import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    selector: 'conversion-error',
    template: `
        <h1>{{message}}</h1> `
})

export class ErrorComponent {

    message: string;

    constructor(
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.route
            .queryParams
            .subscribe(params => {
                this.message = params['message']
            });
    }

}